// Selection share: tooltip on selection -> modal preview (X + IG Story)
// with modern canvas design and share/download actions.
import gsap from 'gsap';
import { bindWaitlist } from './footerWaitlist.js';
// Use bundler-resolved URLs for templates
const landscapeTpl = new URL('../../img/landscape.png', import.meta.url).toString();
const landscapeImagesTpl = new URL('../../img/landscape-images.png', import.meta.url).toString();
const portraitTpl = new URL('../../img/portrait.png', import.meta.url).toString();
const portraitImagesTpl = new URL('../../img/portrait-images.png', import.meta.url).toString();

function createEl(tag, className, html) {
  const el = document.createElement(tag);
  if (className) el.className = className;
  if (html) el.innerHTML = html;
  return el;
}

const ICONS = {
  share: `<svg height="16" width="16" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill="#fff" d="M2,29A1.12,1.12,0,0,1,1.69,29,1,1,0,0,1,1,28V27A19,19,0,0,1,17,8.24V4a1,1,0,0,1,1.6-.8l12,9a1,1,0,0,1,0,1.6l-12,9A1,1,0,0,1,17,22V18.25A18.66,18.66,0,0,0,4.93,25.67L2.81,28.59A1,1,0,0,1,2,29ZM19,6V9.12a1,1,0,0,1-.89,1,17,17,0,0,0-15,14.6l.16-.21A20.68,20.68,0,0,1,17.9,16.11a1,1,0,0,1,.77.26,1,1,0,0,1,.33.74V20l9.33-7Z"/></svg>`,
  nav: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7266 6.57965C10.9204 6.45188 11.1837 6.47284 11.3545 6.64313C11.5252 6.81388 11.5468 7.07799 11.4189 7.27203L11.3545 7.35016L7.20508 11.4996H18C18.276 11.4996 18.4998 11.7236 18.5 11.9996C18.5 12.2757 18.2761 12.4996 18 12.4996H7.20703L11.3545 16.6461C11.5497 16.8412 11.5495 17.1578 11.3545 17.3531C11.1592 17.5482 10.8427 17.5483 10.6475 17.3531L5.64648 12.3521L5.58203 12.273C5.45443 12.0791 5.47598 11.8157 5.64648 11.6451L10.6475 6.64313L10.7266 6.57965Z" fill="currentColor"></path></svg>`,
  clipboard: `<svg fill="#fff" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M456,480H136a24,24,0,0,1-24-24V128a16,16,0,0,1,16-16H456a24,24,0,0,1,24,24V456A24,24,0,0,1,456,480Z"/><path d="M112,80H400V56a24,24,0,0,0-24-24H60A28,28,0,0,0,32,60V376a24,24,0,0,0,24,24H80V112A32,32,0,0,1,112,80Z"/></svg>`,
  check: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z" fill="#fff" /></svg>`,
  email: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.5 7.5H33V6H31.5V7.5ZM31.5 28.5V30H33V28.5H31.5ZM4.5 28.5H3V30H4.5V28.5ZM4.5 7.5V6H3V7.5H4.5ZM18 19.5L17.0502 20.661L18 21.4382L18.9498 20.661L18 19.5ZM30 7.5V28.5H33V7.5H30ZM31.5 27H4.5V30H31.5V27ZM6 28.5V7.5H3V28.5H6ZM4.5 9H31.5V6H4.5V9ZM18.9498 18.339L6.19983 7.90725L4.30011 10.2291L17.0502 20.661L18.9498 18.339ZM29.8002 7.90725L17.0502 18.339L18.9498 20.661L31.6998 10.2291L29.8002 7.90725Z" fill="#A0A0A0"/></svg>`,
  whatsapp: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6862 11.1833C13.9442 11.1937 14.2299 11.2059 14.5015 11.8091C14.6864 12.2207 14.9974 12.987 15.2457 13.5991C15.4297 14.0526 15.5794 14.4214 15.618 14.4985C15.7086 14.6796 15.7687 14.8917 15.6481 15.133C15.6295 15.1701 15.6124 15.2052 15.5962 15.2385C15.5062 15.4224 15.4399 15.5581 15.2863 15.7371C15.225 15.8085 15.1615 15.8856 15.0981 15.9627C14.9741 16.1136 14.8503 16.264 14.7427 16.3716C14.561 16.552 14.3718 16.7482 14.5834 17.1106C14.7951 17.473 15.522 18.6589 16.599 19.6192C17.758 20.6527 18.7645 21.0891 19.2741 21.31C19.3731 21.3529 19.4532 21.3877 19.5121 21.4171C19.8747 21.5982 20.0857 21.5679 20.2972 21.3261C20.5087 21.0843 21.2022 20.2687 21.4438 19.906C21.6856 19.5435 21.9271 19.6036 22.2591 19.7247C22.5912 19.8456 24.372 20.7219 24.7345 20.9032C24.8058 20.9388 24.8725 20.971 24.9342 21.0007C25.1863 21.1222 25.3564 21.2043 25.4292 21.3261C25.5196 21.4776 25.5193 22.2024 25.2177 23.0484C24.916 23.8942 23.437 24.7102 22.7727 24.7705C22.7086 24.7764 22.645 24.7839 22.5796 24.7915C21.9657 24.8637 21.1909 24.9547 18.4254 23.8641C15.0192 22.521 12.7741 19.1908 12.3134 18.5074C12.2761 18.4521 12.2505 18.414 12.2369 18.3958L12.2326 18.3901C12.0364 18.1278 10.7578 16.4181 10.7578 14.6493C10.7578 12.9818 11.5772 12.1073 11.9546 11.7046C11.9806 11.6769 12.0045 11.6514 12.0259 11.628C12.3577 11.2654 12.7502 11.1748 12.9918 11.1748L13.6862 11.1833Z" fill="#A0A0A0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.50391 32.625L5.56096 25.1145C4.29013 22.9111 3.62262 20.4118 3.62568 17.8683C3.62904 9.87662 10.1326 3.375 18.1245 3.375C22.0027 3.37696 25.6429 4.8862 28.3806 7.62586C31.1184 10.3655 32.6247 14.0071 32.6232 17.88C32.6197 25.8711 26.1151 32.3739 18.1243 32.3739H18.118C15.6918 32.373 13.3076 31.7643 11.1898 30.6094L3.50391 32.625ZM18.1288 5.82341C11.4817 5.82341 6.07585 11.2272 6.0735 17.8694C6.07021 20.1375 6.70891 22.3602 7.91575 24.2805L8.20248 24.7364L6.98487 29.1814L11.5459 27.9855L11.9863 28.2465C13.8361 29.3442 15.957 29.9247 18.1198 29.9259H18.1243C24.7665 29.9259 30.1723 24.5215 30.1749 17.879C30.1798 16.2958 29.8708 14.7273 29.2654 13.2644C28.6602 11.8014 27.7707 10.473 26.6485 9.35619C25.5325 8.23323 24.205 7.34279 22.7425 6.73637C21.2802 6.12996 19.7121 5.81966 18.1288 5.82341Z" fill="#A0A0A0"/></svg>`,
  x: `<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.9626 2.69727H30.7417L20.3008 14.6305L32.5837 30.8691H22.9662L15.4335 21.0205L6.81442 30.8691H2.03244L13.2 18.1051L1.41699 2.69727H11.2786L18.0875 11.6992L25.9626 2.69727ZM24.2853 28.0085H26.9334L9.83963 5.40754H6.9979L24.2853 28.0085Z" fill="#A0A0A0"/></svg>`,
  dots: `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 18C20 19.1046 19.1046 20 18 20C16.8954 20 16 19.1046 16 18C16 16.8954 16.8954 16 18 16C19.1046 16 20 16.8954 20 18Z" fill="#A0A0A0"/><path d="M12 18C12 19.1046 11.1046 20 10 20C8.89544 20 8 19.1046 8 18C8 16.8954 8.89544 16 10 16C11.1046 16 12 16.8954 12 18Z" fill="#A0A0A0"/><path d="M28 18C28 19.1046 27.1046 20 26 20C24.8954 20 24 19.1046 24 18C24 16.8954 24.8954 16 26 16C27.1046 16 28 16.8954 28 18Z" fill="#A0A0A0"/></svg>`,
};

function inContainer(range, selector) {
  const node = range.commonAncestorContainer.nodeType === 1
    ? range.commonAncestorContainer
    : range.commonAncestorContainer.parentNode;
  return node && (node.closest?.(selector));
}

function getSelectionTextAndRange(allowedSelector) {
  const sel = window.getSelection();
  if (!sel || sel.isCollapsed || sel.rangeCount === 0) return null;
  const range = sel.getRangeAt(0);
  if (!inContainer(range, allowedSelector)) return null;
  const text = sel.toString().trim();
  if (!text) return null;
  return { text, range };
}

function positionTooltip(tooltip, rect, opts = {}) {
  const { offset = 8, placement = 'top' } = opts;
  const scrollX = window.scrollX || document.documentElement.scrollLeft;
  const scrollY = window.scrollY || document.documentElement.scrollTop;
  const top = placement === 'top'
    ? rect.top + scrollY - tooltip.offsetHeight - offset
    : rect.bottom + scrollY + offset;
  const left = rect.left + scrollX + (rect.width - tooltip.offsetWidth) / 2;
  tooltip.style.top = `${Math.max(8, top)}px`;
  tooltip.style.left = `${Math.max(8, left)}px`;
}

function wrapText(ctx, text, maxWidth, lineHeight) {
  const words = text.split(/\s+/);
  const lines = [];
  let line = '';
  for (let n = 0; n < words.length; n++) {
    const testLine = line ? line + ' ' + words[n] : words[n];
    const metrics = ctx.measureText(testLine);
    if (metrics.width > maxWidth && line) {
      lines.push(line);
      line = words[n];
    } else {
      line = testLine;
    }
  }
  if (line) lines.push(line);
  return lines;
}

function drawRoundedRect(ctx, x, y, w, h, r) {
  const rr = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + rr, y);
  ctx.arcTo(x + w, y, x + w, y + h, rr);
  ctx.arcTo(x + w, y + h, x, y + h, rr);
  ctx.arcTo(x, y + h, x, y, rr);
  ctx.arcTo(x, y, x + w, y, rr);
  ctx.closePath();
}

async function loadTemplateBitmap(src) {
  // Prefer fetch + createImageBitmap for reliability
  try {
    if (window.createImageBitmap) {
      const res = await fetch(src, { cache: 'force-cache' });
      if (!res.ok) throw new Error('Template fetch failed');
      const blob = await res.blob();
      const bmp = await createImageBitmap(blob);
      return { bmp };
    }
  } catch (_) {
    // fall back to HTMLImageElement
  }
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.decoding = 'async';
    img.onload = () => resolve({ img });
    img.onerror = (e) => reject(e);
    img.src = src;
  });
}

function fitTextInto(ctx, text, areaWidth, areaHeight, baseFontSize, lineHeightRatio, fontFamily) {
  let fs = baseFontSize;
  for (; fs >= 24; fs -= 2) {
    ctx.font = `400 ${fs}px ${fontFamily}`;
    const lineHeight = Math.round(fs * lineHeightRatio);
    const lines = wrapText(ctx, text, areaWidth, lineHeight);
    const h = lines.length * lineHeight;
    if (h <= areaHeight) {
      return { fs, lineHeight, lines };
    }
  }
  // If still overflowing, truncate with ellipsis
  ctx.font = `400 24px ${fontFamily}`;
  const lineHeight = Math.round(24 * lineHeightRatio);
  const lines = wrapText(ctx, text, areaWidth, lineHeight);
  const maxLines = Math.floor(areaHeight / lineHeight);
  const clipped = lines.slice(0, Math.max(0, maxLines));
  if (clipped.length) {
    const last = clipped[clipped.length - 1];
    clipped[clipped.length - 1] = last.replace(/(.{0,})$/, (m) => {
      let s = m;
      while (ctx.measureText(s + '…').width > areaWidth && s.length > 0) {
        s = s.slice(0, -1);
      }
      return s + '…';
    });
  }
  return { fs: 24, lineHeight, lines: clipped };
}

async function textToImageFixed(text, { width, height, tplSrc, theme = 'light' } = {}) {
  // Truncate text if too long
  let processingText = text.trim();
  if (processingText.length > 250) {
    processingText = processingText.substring(0, 247).trim() + '...';
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  // Ensure Tobias font is available for canvas
  try {
    if (document?.fonts) {
      await Promise.race([
        document.fonts.load('16px "TWKLausanne"'),
        new Promise((resolve) => setTimeout(resolve, 200))
      ]);
    }
  } catch (_) { /* no-op */ }

  // Draw provided template as full background
  ctx.clearRect(0, 0, width, height);
  try {
    const res = await loadTemplateBitmap(tplSrc);
    if (res?.bmp) ctx.drawImage(res.bmp, 0, 0, width, height);
    else if (res?.img) ctx.drawImage(res.img, 0, 0, width, height);
    else throw new Error('No bitmap');
  } catch (err) {
    const g = ctx.createLinearGradient(0, 0, 0, height);
    g.addColorStop(0, '#ffffff');
    g.addColorStop(1, '#f7f7f7');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, width, height);
  }

  const fontFamily = 'TWKLausanne, Inter, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
  ctx.textBaseline = 'top';
  ctx.textAlign = 'center';
  ctx.fillStyle = '#0d0d0f';

  // Determine layout based on template type
  const isLandscape = width > height;

  const innerPad = Math.round(Math.min(width, height) * 0.08);

  // --- EDIT THESE OFFSETS ---
  const OFFSETS = {
    landscape: {
      textX: width / 2,
      textY: 650,
      textW: 900
    },
    landscapeImages: {
      textX: 620,
      textY: 650,
      textW: 800
    },
    portrait: {
      textX: width / 2,
      textY: 700,
      textW: 700
    },
    portraitImages: {
      textX: width / 2,
      textY: 930,
      textW: 700
    }
  };

  let cfg;
  if (tplSrc === landscapeTpl) cfg = OFFSETS.landscape;
  else if (tplSrc === landscapeImagesTpl) cfg = OFFSETS.landscapeImages;
  else if (tplSrc === portraitTpl) cfg = OFFSETS.portrait;
  else cfg = OFFSETS.portraitImages;

  const { textX, textY, textW } = cfg;
  const textH = height - textY - innerPad;

  // Base font sizing
  const baseFs = isLandscape ? 64 : 48;
  const targetLh = isLandscape ? 60 : 44;
  const lhRatio = targetLh / baseFs;

  if ('letterSpacing' in ctx) ctx.letterSpacing = '-2px';

  const fit = fitTextInto(ctx, processingText, textW, textH, baseFs, lhRatio, fontFamily);
  ctx.font = `400 ${fit.fs}px ${fontFamily}`;

  let y = textY;
  for (const line of fit.lines) {
    ctx.fillText(line, textX, y);
    y += fit.lineHeight;
  }

  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve({ blob, canvas }), 'image/png', 1);
  });
}

async function shareViaWebShare(blob, filename = 'quote.png') {
  if (!blob) return { method: 'unsupported' };
  const type = blob.type || 'image/png';
  const isJpeg = type.includes('jpeg') || type.includes('jpg');
  const safeName = filename || (isJpeg ? 'image.jpg' : 'image.png');
  const file = new File([blob], safeName, { type });

  // Use system share if available
  if (navigator.canShare && navigator.canShare({ files: [file] }) && typeof navigator.share === 'function') {
    try {
      await navigator.share({ files: [file], title: 'Genie', text: '' });
      return { method: 'navigator.share' };
    } catch (e) {
      // user canceled or share failed; continue to clipboard
    }
  }

  // Clipboard fallback on desktop or failure
  try {
    if (navigator.clipboard && window.ClipboardItem) {
      const itemType = isJpeg ? 'image/jpeg' : 'image/png';
      await navigator.clipboard.write([new ClipboardItem({ [itemType]: blob })]);
      return { method: 'clipboard' };
    }
  } catch (e) {
    // ignore
  }
  return { method: 'unsupported' };
}

function forceDownload(blob, filename = 'quote.png') {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function showToast(message) {
  const toast = createEl('div', 'share-toast', message);
  document.body.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('is-visible'));
  setTimeout(() => {
    toast.classList.remove('is-visible');
    setTimeout(() => toast.remove(), 300);
  }, 2400);
}

export default function initShareQuote() {
  if (document.body.dataset.shareInit === '1') return;
  // Create/reuse tooltip
  const tooltip = document.querySelector('.share-tooltip') || createEl('div', 'share-tooltip');
  tooltip.innerHTML = `
    <button type="button" class="share-tooltip__btn" aria-label="Share">
      ${ICONS.share}
      <span>Share</span>
    </button>
  `;
  if (!document.body.contains(tooltip)) document.body.appendChild(tooltip);
  tooltip.style.display = 'none';

  const btn = tooltip.querySelector('.share-tooltip__btn');
  let currentText = '';
  let suppressSelection = false; // avoid re-showing tooltip when we are interacting
  let opening = false; // avoid double generation/modal

  // Modal (create if missing)
  let modal = document.querySelector('.share-modal');
  if (!modal) {
    modal = createEl('div', 'share-modal');
    modal.innerHTML = `
      <div class="share-modal__backdrop"></div>
      <div class="share-modal__content" data-lenis-prevent>
        <button class="share-modal__close" aria-label="Close">×</button>
        <div class="share-carousel">
          <button class="share-carousel__nav share-carousel__nav--prev" aria-label="Previous">
            ${ICONS.nav}
          </button>
          <div class="share-carousel__viewport">
            <div class="share-carousel__track">
              <div class="share-slide" data-kind="landscape">
                <div class="share-slide__inner">
                  <div class="share-slide__media share-landscape__media"></div>
                </div>
              </div>
              <div class="share-slide" data-kind="landscape-images">
                <div class="share-slide__inner">
                  <div class="share-slide__media share-landscape-images__media"></div>
                </div>
              </div>
              <div class="share-slide" data-kind="portrait">
                <div class="share-slide__inner">
                  <div class="share-slide__media share-portrait__media"></div>
                </div>
              </div>
              <div class="share-slide" data-kind="portrait-images">
                <div class="share-slide__inner">
                  <div class="share-slide__media share-portrait-images__media"></div>
                </div>
              </div>
            </div>
          </div>
          <button class="share-carousel__nav share-carousel__nav--next" aria-label="Next">
            ${ICONS.nav}
          </button>
        </div>
        <div class="share-footer">
          <div class="share-footer__form">
            <div class="form">
              <input type="email" placeholder="Email" value="" class="form__email">
              <div class="form__submit">Join the waitlist</div>
            </div>
            <div class="success">
              <button type="button" class="success__close" aria-label="Close">×</button>
              <div class="success__logo"></div>
              <h3>There are <span class="success__position"></span> people ahead of you on the waitlist</h3>
              <h4>Share Genie to friends, to move up on the waitlist and get special perks.</h4>
              <div class="success__copy">
                <input type="text" readonly value="" />
                <button type="button">
                  ${ICONS.clipboard}
                  <div class="check-wrap">${ICONS.check}</div>
                </button>
              </div>
              <div class="share">
                <div><a href="#" class="success__email" target="_blank">${ICONS.email}</a></div>
                <div><a href="#" class="success__whatsapp" target="_blank">${ICONS.whatsapp}</a></div>
                <div><a href="#" class="success__x" target="_blank">${ICONS.x}</a></div>
                <div><button class="success__share">${ICONS.dots}</button></div>
              </div>
            </div>
          </div>
          <div class="share-footer__buttons">

            <button class="btn share-action-btn">Share</button>
            <button class="btn share-dl-btn">Download</button>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.style.display = 'none';

    // Bind waitlist form now that we have the markup
    const footerFormContainer = modal.querySelector('.share-footer__form');
    if (footerFormContainer) {
      bindWaitlist(footerFormContainer);
    }
  }

  const modalBackdrop = modal.querySelector('.share-modal__backdrop');
  const modalClose = modal.querySelector('.share-modal__close');

  const landscapeWrap = modal.querySelector('.share-landscape__media');
  const landscapeImagesWrap = modal.querySelector('.share-landscape-images__media');
  const portraitWrap = modal.querySelector('.share-portrait__media');
  const portraitImagesWrap = modal.querySelector('.share-portrait-images__media');
  // carousel refs
  const carouselTrack = modal.querySelector('.share-carousel__track');
  const carouselSlides = Array.from(carouselTrack?.children || []);
  const prevBtn = modal.querySelector('.share-carousel__nav--prev');
  const nextBtn = modal.querySelector('.share-carousel__nav--next');
  let currentSlideIndex = 0;
  let isSliding = false;
  let landscapeCanvas = null, landscapeImagesCanvas = null, portraitCanvas = null, portraitImagesCanvas = null;
  let landscapeBlob = null, landscapeImagesBlob = null, portraitBlob = null, portraitImagesBlob = null;

  async function handleModalDblClick() {
    const { blob } = await getCurrentBlob();
    if (!blob) return;
    try {
      if (navigator.clipboard && window.ClipboardItem) {
        const itemType = blob.type.includes('jpeg') ? 'image/jpeg' : 'image/png';
        await navigator.clipboard.write([new ClipboardItem({ [itemType]: blob })]);
        showToast('Copied to clipboard');
      } else {
        showToast('Clipboard not supported');
      }
    } catch (e) {
      showToast('Copy failed');
    }
  }


  function hideTooltip() {
    if (tooltip.style.display === 'none') return;
    gsap.killTweensOf(tooltip);
    gsap.to(tooltip, {
      opacity: 0,
      scale: 0,
      duration: 0.16,
      ease: 'power2.inOut',
      onComplete: () => { tooltip.style.display = 'none'; }
    });
  }

  const isCoarse = (() => {
    try { return window.matchMedia && window.matchMedia('(pointer: coarse)').matches; } catch (_) { return 'ontouchstart' in window; }
  })();

  function showTooltipForRange(range) {
    const rect = range.getBoundingClientRect();
    if (!rect || (rect.width === 0 && rect.height === 0)) return;
    tooltip.style.display = 'block';
    tooltip.style.opacity = '0';
    tooltip.style.top = '0px';
    tooltip.style.left = '0px';
    gsap.killTweensOf(tooltip);
    requestAnimationFrame(() => {
      const placement = isCoarse ? 'bottom' : 'top';
      positionTooltip(tooltip, rect, { placement });
      const origin = placement === 'top' ? '50% 100%' : '50% 0%';
      gsap.set(tooltip, { scale: 0, transformOrigin: origin });
      gsap.to(tooltip, { opacity: 1, scale: 1, duration: 0.22, ease: 'back.out(1.7)' });
    });
  }

  function handlePointerUp() {
    const res = getSelectionTextAndRange('.page-wrap');
    if (!res) return hideTooltip();
    currentText = res.text;
    showTooltipForRange(res.range);
  }

  // Drawer-like full-viewport panel (resolve dynamically to avoid Barba stale refs)
  const getPageWrapper = () => (
    document.querySelector('[data-barba="container"] .page-wrapper') ||
    document.querySelector('.page-wrapper')
  );

  function layoutCarousel() {
    if (!carouselSlides.length) return;
    carouselSlides.forEach((slide, i) => {
      const inner = slide.querySelector('.share-slide__inner') || slide;
      gsap.set(inner, { x: 0, opacity: i === currentSlideIndex ? 1 : 0 });
      slide.classList.toggle('is-active', i === currentSlideIndex);
    });
  }

  function updateActiveSlideStyles() {
    if (!carouselSlides.length) return;
    carouselSlides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === currentSlideIndex);
    });
  }

  function gotoSlide(index) {
    if (!carouselSlides.length || isSliding) return;
    const max = carouselSlides.length;
    const prevIndex = currentSlideIndex;
    const nextIndex = (index % max + max) % max;
    if (prevIndex === nextIndex) return;
    isSliding = true;
    const dir = ((prevIndex + 1) % max === nextIndex) ? 1 : -1;
    const easeIn = 'power3.out';
    const easeOut = 'power2.in';

    const prevSlide = carouselSlides[prevIndex];
    const nextSlide = carouselSlides[nextIndex];
    const prevInner = prevSlide.querySelector('.share-slide__inner') || prevSlide;
    const nextInner = nextSlide.querySelector('.share-slide__inner') || nextSlide;

    // Stage next slide offscreen in direction
    const offset = Math.max(240, window.innerWidth * 0.6);
    gsap.set(nextInner, { x: dir * offset, opacity: 0 });

    const tl = gsap.timeline({ onComplete: () => { isSliding = false; } });
    // 1) prev out
    tl.to(prevInner, { x: -dir * offset, opacity: 0, duration: 0.38, ease: easeOut })
      .set(prevInner, { x: 0 })
      // 2) switch active
      .add(() => { currentSlideIndex = nextIndex; updateActiveSlideStyles(); })
      // 3) next in
      .to(nextInner, { x: 0, opacity: 1, duration: 0.4, ease: easeIn }, "+=0.02");
  }

  // keep layout responsive while open
  window.addEventListener('resize', () => {
    if (document.body.classList.contains('body--modal-open')) {
      layoutCarousel();
    }
  });

  function openModal() {
    const backdrop = modal.querySelector('.share-modal__backdrop');
    const content = modal.querySelector('.share-modal__content');

    // Ensure layout and initial states
    modal.style.display = 'block';
    document.body.classList.add('body--modal-open');
    try { window.lenis?.stop(); } catch (_) { }

    const pw = getPageWrapper();
    gsap.killTweensOf([backdrop, content, pw].filter(Boolean));

    // Content becomes a full-viewport panel sliding from bottom
    gsap.set(content, {
      position: 'absolute',
      left: 0,
      top: '3vh',
      width: '100%',
      height: '97vh',
      opacity: 1,
      xPercent: 0,
      yPercent: 0,
      x: 0,
      y: '100vh',
      willChange: 'transform'
    });

    const pw2 = getPageWrapper();
    if (pw2) gsap.set(pw2, { y: '0vh', willChange: 'transform' });

    try { layoutCarousel(); gotoSlide(currentSlideIndex); } catch (_) { }

    const ease = (gsap.parseEase && gsap.parseEase('custom')) || 'power3.inOut';

    // Defer the animation to the next frame to ensure initial state is painted
    requestAnimationFrame(() => {
      const tl = gsap.timeline({ defaults: { ease } });
      // Veil in quickly
      tl.set(backdrop, { pointerEvents: 'auto' }, 0)
        .to(backdrop, { opacity: 1, duration: 0.18 }, 0);
      // Slide page up and panel in simultaneously
      const pw3 = getPageWrapper();
      if (pw3) tl.set(pw3, { transformOrigin: 'top' }, 0);
      if (pw3) tl.to(pw3, { scale: 0.9, duration: 0.5 }, 0);
      tl.to('.header', { y: '3vh', duration: 0.5 }, 0);
      tl.to(content, { y: 0, duration: 0.5 }, 0);
      // Also ensure slides baseline states
      layoutCarousel();
    });

    // Update header text and bind dblclick (Desktop only)
    if (!isCoarse) {
      const headerP = document.querySelector('.header p');
      if (headerP) {
        headerP.textContent = 'Double click to save to clipboard';
        headerP.classList.add('is-instruction');
      }
      modal.addEventListener('dblclick', handleModalDblClick);
    }
  }

  function closeModal() {
    const backdrop = modal.querySelector('.share-modal__backdrop');
    const content = modal.querySelector('.share-modal__content');

    const pw4 = getPageWrapper();
    gsap.killTweensOf([backdrop, content, pw4].filter(Boolean));

    const ease = (gsap.parseEase && gsap.parseEase('custom')) || 'power3.inOut';
    const tl = gsap.timeline({
      defaults: { ease }, onComplete: () => {
        modal.style.display = 'none';
        document.body.classList.remove('body--modal-open');
        suppressSelection = false;
        opening = false;
        try { window.lenis?.start(); } catch (_) { }
        try {
          gsap.set(content, { clearProps: 'transform,willChange' });
          const pw5 = getPageWrapper();
          if (pw5) gsap.set(pw5, { clearProps: 'transform,willChange' });
        } catch (_) { }
      }
    });

    // Bring veil back shortly while reversing
    tl.set(backdrop, { pointerEvents: 'auto' }, 0)
      .to(backdrop, { opacity: 1, duration: 0.15 }, 0);
    // Slide panel down and page back in place
    tl.to(content, { y: '100vh', duration: 0.65 }, 0);
    const pw6 = getPageWrapper();
    if (pw6) tl.to(pw6, { y: '0vh', scale: 1, duration: 0.65 }, 0);
    tl.to('.header', { y: 0, duration: 0.65 }, 0);
    // Fade veil out and finish
    tl.to(backdrop, { opacity: 0, duration: 0.2 }, 0.45);

    // Revert header text and unbind dblclick (Desktop only)
    if (!isCoarse) {
      const headerP = document.querySelector('.header p');
      if (headerP) {
        headerP.textContent = 'Genie';
        headerP.classList.remove('is-instruction');
      }
      modal.removeEventListener('dblclick', handleModalDblClick);
    }
  }

  async function handleShareClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!currentText || opening) return;
    opening = true;
    suppressSelection = true;
    hideTooltip();
    // clear system selection to avoid OS tooltip conflicting on mobile
    try { const sel = window.getSelection(); sel && sel.removeAllRanges && sel.removeAllRanges(); } catch (_) { }


    // Generate quote previews
    landscapeWrap.innerHTML = '';
    landscapeImagesWrap.innerHTML = '';
    portraitWrap.innerHTML = '';
    portraitImagesWrap.innerHTML = '';

    landscapeCanvas = null; landscapeImagesCanvas = null; portraitCanvas = null; portraitImagesCanvas = null;
    landscapeBlob = null; landscapeImagesBlob = null; portraitBlob = null; portraitImagesBlob = null;

    const l = await textToImageFixed(currentText, { width: 2400, height: 1350, tplSrc: landscapeTpl });
    const li = await textToImageFixed(currentText, { width: 2400, height: 1350, tplSrc: landscapeImagesTpl });
    const p = await textToImageFixed(currentText, { width: 1080, height: 1350, tplSrc: portraitTpl });
    const pi = await textToImageFixed(currentText, { width: 1080, height: 1350, tplSrc: portraitImagesTpl });

    landscapeCanvas = l.canvas; landscapeBlob = l.blob;
    landscapeImagesCanvas = li.canvas; landscapeImagesBlob = li.blob;
    portraitCanvas = p.canvas; portraitBlob = p.blob;
    portraitImagesCanvas = pi.canvas; portraitImagesBlob = pi.blob;

    // Landscape style
    [landscapeCanvas, landscapeImagesCanvas].forEach(c => {
      c.style.width = '100%';
      c.style.height = 'auto';
    });
    // Portrait style
    [portraitCanvas, portraitImagesCanvas].forEach(c => {
      c.style.width = 'auto';
      c.style.height = '100%';
    });

    landscapeWrap.appendChild(landscapeCanvas);
    landscapeImagesWrap.appendChild(landscapeImagesCanvas);
    portraitWrap.appendChild(portraitCanvas);
    portraitImagesWrap.appendChild(portraitImagesCanvas);

    currentSlideIndex = 0;
    openModal();
  }

  // Use pointer events when available; otherwise fall back to touchend+click
  if ('onpointerup' in window) {
    btn.addEventListener('pointerup', handleShareClick);
  } else {
    btn.addEventListener('touchend', (e) => { e.preventDefault(); handleShareClick(e); }, { passive: false });
    btn.addEventListener('click', handleShareClick);
  }

  document.addEventListener('mouseup', handlePointerUp);
  document.addEventListener('touchend', handlePointerUp, { passive: true });

  // On mobile, reposition tooltip while user drags selection handles
  let selTimer = null;
  document.addEventListener('selectionchange', () => {
    if (!isCoarse) return;
    if (suppressSelection) return;
    if (selTimer) clearTimeout(selTimer);
    selTimer = setTimeout(() => {
      const res = getSelectionTextAndRange('.page__content, .page-wrap, .page');
      if (res && res.text) {
        currentText = res.text;
        showTooltipForRange(res.range);
      } else {
        hideTooltip();
      }
    }, 50);
  });

  // Hide when clicking elsewhere or pressing ESC
  document.addEventListener('mousedown', (e) => {
    if (!tooltip.contains(e.target)) hideTooltip();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { hideTooltip(); closeModal(); }
  });

  // Modal actions
  modalBackdrop.addEventListener('click', closeModal);
  modalClose.addEventListener('click', closeModal);
  if (prevBtn) prevBtn.addEventListener('click', () => gotoSlide(currentSlideIndex - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => gotoSlide(currentSlideIndex + 1));

  // arrow key nav when modal is open
  document.addEventListener('keydown', (e) => {
    if (!document.body.classList.contains('body--modal-open')) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); gotoSlide(currentSlideIndex + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); gotoSlide(currentSlideIndex - 1); }
  });



  // Shared actions
  async function getCurrentBlob() {
    if (currentSlideIndex === 0) {
      if (!landscapeBlob && landscapeCanvas) landscapeBlob = await new Promise(r => landscapeCanvas.toBlob(r, 'image/png', 1));
      return { blob: landscapeBlob, name: 'quote-landscape.png' };
    } else if (currentSlideIndex === 1) {
      if (!landscapeImagesBlob && landscapeImagesCanvas) landscapeImagesBlob = await new Promise(r => landscapeImagesCanvas.toBlob(r, 'image/png', 1));
      return { blob: landscapeImagesBlob, name: 'quote-landscape-images.png' };
    } else if (currentSlideIndex === 2) {
      if (!portraitBlob && portraitCanvas) portraitBlob = await new Promise(r => portraitCanvas.toBlob(r, 'image/png', 1));
      return { blob: portraitBlob, name: 'quote-portrait.png' };
    } else {
      if (!portraitImagesBlob && portraitImagesCanvas) portraitImagesBlob = await new Promise(r => portraitImagesCanvas.toBlob(r, 'image/png', 1));
      return { blob: portraitImagesBlob, name: 'quote-portrait-images.png' };
    }
  }

  const shareBtn = modal.querySelector('.share-action-btn');
  const dlBtn = modal.querySelector('.share-dl-btn');

  if (shareBtn) {
    shareBtn.addEventListener('click', async (e) => {
      e.preventDefault(); e.stopPropagation();
      const { blob, name } = await getCurrentBlob();
      const { method } = await shareViaWebShare(blob, name);
      if (method === 'clipboard') showToast('Copied');
      if (method === 'unsupported') showToast('Not possible');
    });
  }

  if (dlBtn) {
    dlBtn.addEventListener('click', async (e) => {
      e.preventDefault(); e.stopPropagation();
      const { blob, name } = await getCurrentBlob();
      forceDownload(blob, name);
    });
  }


  // Initialize baseline active state for safety
  layoutCarousel();
  document.body.dataset.shareInit = '1';
}
